document.addEventListener('cart-drawer-opened', () => {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((response) => {
      if (!Array.isArray(response.items)) {
        throw new Error('no cart items');
      }

      const cartDrawerViewedEventPublished = window.Shopify.analytics.publish(
        'cart_drawer_viewed',
        {
          data: response,
        },
      );

      if (!cartDrawerViewedEventPublished) {
        throw new Error('cart_drawer_viewed event not published');
      }
    })
    .catch((error) => {
      console.error('Tracking skipped: cart_drawer_viewed event.', error);
    });
});

document.addEventListener('quick-add-modal-opened', (event) => {
  const { productUrl, firstOrSelectedVariantId } = event.detail;

  fetch(`${productUrl}.json`)
    .then((response) => response.json())
    .then((response) => {
      if (!('product' in response)) {
        throw new Error('no product');
      }

      const quickAddModalViewedEventPublished =
        window.Shopify.analytics.publish('quick_add_modal_viewed', {
          data: response.product,
          variantId: firstOrSelectedVariantId,
          currency: window.Shopify.currency.active,
        });

      if (!quickAddModalViewedEventPublished) {
        throw new Error('quick_add_modal_viewed event not published');
      }
    })
    .catch((error) => {
      console.error('Tracking skipped: quick_add_modal_viewed event.', error);
    });
});
